// FILE: src/pages/Mobile/MobileApp.js
// Android-only shell — shows Clock In/Out + Attendance Matrix only.
// Employees use the full website for everything else.

import React, { useState } from 'react';
import { Box, BottomNavigation, BottomNavigationAction, Paper, CircularProgress } from '@mui/material';
import { AccessTime, CalendarMonth, Logout } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';
import MobileClockPage from './MobileClockPage';
import MobileAttendancePage from './MobileAttendancePage';
import LoginPage from '../LoginPage';

const MobileApp = () => {
  const [tab, setTab] = useState(0);
  const { user, loading, logout } = useAuth();

  // While auth state is loading, show a spinner (prevents flash of login page)
  if (loading) {
    return (
      <Box sx={{
        display: 'flex', justifyContent: 'center',
        alignItems: 'center', height: '100vh', bgcolor: '#0f172a'
      }}>
        <CircularProgress sx={{ color: '#4ade80' }} size={60} />
      </Box>
    );
  }

  // Not logged in → show login page directly (no redirect, no buffering)
  if (!user) {
    return <LoginPage />;
  }

  // Logged in → show mobile app
  return (
    <Box sx={{ pb: 8, minHeight: '100vh', bgcolor: '#f8fafc' }}>

      {/* Page content */}
      {tab === 0 && <MobileClockPage />}
      {tab === 1 && <MobileAttendancePage />}

      {/* Bottom navigation */}
      <Paper sx={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        zIndex: 100, borderTop: '1px solid #e2e8f0'
      }} elevation={3}>
        <BottomNavigation
          value={tab}
          onChange={(e, newVal) => {
            if (newVal === 2) { logout(); return; }
            setTab(newVal);
          }}
          sx={{ bgcolor: '#0f172a' }}
        >
          <BottomNavigationAction
            label="Clock In/Out"
            icon={<AccessTime />}
            sx={{ color: tab === 0 ? '#4ade80' : '#64748b', '&.Mui-selected': { color: '#4ade80' } }}
          />
          <BottomNavigationAction
            label="Attendance"
            icon={<CalendarMonth />}
            sx={{ color: tab === 1 ? '#4ade80' : '#64748b', '&.Mui-selected': { color: '#4ade80' } }}
          />
          <BottomNavigationAction
            label="Logout"
            icon={<Logout />}
            sx={{ color: '#ef4444' }}
          />
        </BottomNavigation>
      </Paper>
    </Box>
  );
};

export default MobileApp;